// src/pages/Relatorios/RelatorioVendas.jsx
import React from 'react';

const RelatorioVendas = () => {
  return (
    <div>
      <h2>Relatório de Vendas</h2>
      <p>Aqui você pode implementar o relatório de vendas.</p>
    </div>
  );
};

export default RelatorioVendas;
